import styled from 'styled-components';
import { variables } from '../../../styles/variables';

export const FiltersContainer = styled('div')`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap-reverse;
  justify-content: flex-end;
  button {
    overflow: hidden;
  }
  button img,
  span.anticon-loading {
    margin-left: 20px;
    margin-right: 0;
  }
  span.selected {
    position: relative;
    padding: 0 5px;
    transition: max-width 0.5s;
    color: ${variables.colorDecorator};
    overflow: hidden;
  }
  @media (max-width: 992px) {
    align-content: flex-start;
  }
`;

export const FilterContainer = styled('div')`
  position: relative;
  &#main {
    order: 1;
  }
`;
